import type { AiChatPanelMode, AiImageAspectRatioId } from './types';

export const AI_CHAT_DEFAULT_MODEL_API = 'deepseek-v4-flash';

export const AI_CHAT_PANEL_MODE_OPTIONS: Array<{
  id: AiChatPanelMode;
  label: string;
  enabled: boolean;
}> = [
  { id: 'CHAT', label: 'AI会话', enabled: true },
  { id: 'IMAGE', label: '图片生成', enabled: true },
  { id: 'VIDEO', label: '视频生成', enabled: false },
  { id: 'AVATAR', label: '数字人', enabled: false },
];

export const AI_IMAGE_COUNT_OPTIONS = [1, 2, 3, 4] as const;

export const AI_IMAGE_ASPECT_RATIO_OPTIONS: Array<{
  id: AiImageAspectRatioId;
  label: string;
}> = [
  { id: '21:9', label: '21:9' },
  { id: '16:9', label: '16:9' },
  { id: '3:2', label: '3:2' },
  { id: '4:3', label: '4:3' },
  { id: '1:1', label: '1:1' },
  { id: '3:4', label: '3:4' },
  { id: '2:3', label: '2:3' },
  { id: '9:16', label: '9:16' },
];

/** 2K 基准像素（与产品设计稿一致） */
export const AI_IMAGE_SIZE_2K: Record<AiImageAspectRatioId, { width: number; height: number }> = {
  '21:9': { width: 3024, height: 1296 },
  '16:9': { width: 2560, height: 1440 },
  '3:2': { width: 2496, height: 1664 },
  '4:3': { width: 2304, height: 1728 },
  '1:1': { width: 2048, height: 2048 },
  '3:4': { width: 1728, height: 2304 },
  '2:3': { width: 1664, height: 2496 },
  '9:16': { width: 1440, height: 2560 },
};

/** 4K 基准像素（厂商限制，非 2K 简单翻倍） */
export const AI_IMAGE_SIZE_4K: Record<AiImageAspectRatioId, { width: number; height: number }> = {
  '21:9': { width: 4032, height: 1728 },
  '16:9': { width: 3840, height: 2160 },
  '3:2': { width: 3840, height: 2560 },
  '4:3': { width: 4096, height: 3072 },
  '1:1': { width: 4096, height: 4096 },
  '3:4': { width: 3072, height: 4096 },
  '2:3': { width: 2560, height: 3840 },
  '9:16': { width: 2160, height: 3840 },
};

export const AI_IMAGE_RESOLUTION_LABELS = {
  '2k': '高清2K',
  '4k': '超清4K',
} as const;
